<div class="training-page">
  <header class="page-header">
    <div>
      <p class="eyebrow">As-built training</p>
      <h1>Training Sets</h1>
      <p>Create a set, upload plans, correct the AI drawing, then turn the set on when it is ready.</p>
    </div>
  </header>

  <section class="upload-panel">
    <div class="upload-copy">
      <h2>New training set</h2>
      <p>Use one set for a plan type, region, or customer workflow. You can turn it on or off at any time.</p>
    </div>

    <div class="form-row">
      <label>
        <span>Name</span>
        <input [ngModel]="name()" (ngModelChange)="name.set($event)" placeholder="Residential drainage plans">
      </label>
      <label>
        <span>Description</span>
        <input [ngModel]="description()" (ngModelChange)="description.set($event)" placeholder="Optional notes for this training set">
      </label>
    </div>

    <div class="upload-actions">
      <button class="btn-primary" type="button" (click)="createSession()" [disabled]="isSaving()">
        {{ isSaving() ? 'Creating...' : 'Create Training Set' }}
      </button>
    </div>
  </section>

  <section class="samples-section">
    <div class="section-heading">
      <div>
        <h2>Available Sets</h2>
        <p>Open a set to add plans and review corrected AI drawings.</p>
      </div>
      <button class="btn-light" type="button" (click)="loadSessions()" [disabled]="isLoading()">Refresh</button>
    </div>

    <div class="session-grid" *ngIf="!isLoading(); else loadingState">
      <article class="session-card" *ngFor="let session of sessions()" (click)="openSession(session)">
        <div class="sample-topline">
          <span class="status-pill" [ngClass]="'status-' + session.status.toLowerCase()">{{ session.status }}</span>
          <small>{{ formatDate(session.updated_at || session.created_at) }}</small>
        </div>
        <h3>{{ session.name }}</h3>
        <p>{{ session.description || 'No description added.' }}</p>

        <div class="metric-row">
          <div><strong>{{ session.sample_count || 0 }}</strong><span>Plans</span></div>
          <div><strong>{{ session.submitted_count || 0 }}</strong><span>Submitted</span></div>
          <div><strong>{{ session.approved_count || 0 }}</strong><span>Approved</span></div>
        </div>

        <div class="sample-actions">
          <button class="btn-approve" type="button" (click)="setStatus(session, 'Active', $event)" [disabled]="session.status === 'Active'">Turn On</button>
          <button class="btn-light" type="button" (click)="setStatus(session, 'Draft', $event)" [disabled]="session.status === 'Draft'">Draft</button>
          <button class="btn-reject" type="button" (click)="setStatus(session, 'Disabled', $event)" [disabled]="session.status === 'Disabled'">Turn Off</button>
        </div>
      </article>

      <div class="empty-state" *ngIf="sessions().length === 0">
        <h3>No training sets yet</h3>
        <p>Create a training set, then add plans for the AI to learn from corrected drawings.</p>
      </div>
    </div>

    <ng-template #loadingState>
      <div class="session-grid">
        <div class="session-card skeleton" *ngFor="let i of [1,2,3]"></div>
      </div>
    </ng-template>
  </section>
</div>
